import { useState } from 'react';

import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Button, Modal, Tooltip } from '@iwoca/orion';
import classNames from 'classnames';

import styles from '../SpendingLimitCard.module.css';
import refreshIconSvg from './refreshIcon.svg';
import refreshIconGreySvg from './refreshIconGrey.svg';
import { useGetANTFormalOffers } from '../../hooks/useGetANTFormalOffers';
import { useUpdateTurnover } from '../../hooks/useUpdateTurnover';

export const RefreshExpiredLimits = ({
    loading,
    setIsSpendingLimitDrawerOpen,
    refreshSpendingLimit,
    className
}: {
    loading: boolean;
    setIsSpendingLimitDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
    refreshSpendingLimit: () => void;
    className?: string;
}) => {
    const [showSupersedeModal, setShowSupersedeModal] = useState(false);
    const { offers: antOffers } = useGetANTFormalOffers();
    const coreANTOffers = antOffers.filter(
        (offer) => offer?.product_type !== 'iwocapay'
    );

    const { shouldUpdateTurnover } = useUpdateTurnover();

    const handleClick = () => {
        if (coreANTOffers.length > 0) {
            return setShowSupersedeModal(true);
        }
        setIsSpendingLimitDrawerOpen(true);
        if (!shouldUpdateTurnover) {
            refreshSpendingLimit();
        }
    };

    return (
        <>
            <Modal
                isOpen={showSupersedeModal}
                onClose={() => setShowSupersedeModal(false)}
            >
                <h1 className={styles.creditFacilityWarningTitle}>
                    Once you hit continue we’ll need to re-run your existing
                    Flexi-Loan offer for{' '}
                    <FormattedCurrency
                        value={coreANTOffers[0]?.available_credit || 0}
                    />
                </h1>
                <p className={styles.creditFacilityWarningText}>
                    Don’t worry - you won’t need to give us any more documents
                    to do this. To see your Flexi-Loan offer, go to your iwoca
                    dashboard.
                </p>
                <div className={styles.creditFacilityButtonContainer}>
                    <Button onClick={() => refreshSpendingLimit()}>
                        Continue with iwocaPay
                    </Button>
                    <Button
                        onClick={() => setShowSupersedeModal(false)}
                        variant="tertiary"
                    >
                        Go back
                    </Button>
                </div>
            </Modal>
            <Tooltip
                content="Subject to approval and reassessed every 30 days - if something changes with your business the amounts might change."
                placement="top"
                variant="primary"
                className={styles.secureLimitButtonTooltip}
            >
                <button
                    className={classNames(
                        styles.secureLimitButton,
                        {
                            [styles.secureLimitButtonDisabled]: loading
                        },
                        className
                    )}
                    onClick={() => handleClick()}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <img
                                src={refreshIconGreySvg}
                                className={styles.spinningIcon}
                                alt=""
                            />
                            Checking limit...
                        </>
                    ) : (
                        <div className={styles.secureLimitButton}>
                            <img src={refreshIconSvg} alt="" />
                            Secure my limit
                        </div>
                    )}
                </button>
            </Tooltip>
        </>
    );
};
